// extracted by mini-css-extract-plugin
var _1 = "B1kxBPFZl0blXpQ5ayh9";
var _2 = "fagr2m2U8eyKvuHZ1PFj";
export { _1 as "paragraph", _2 as "root" }
